import * as lib from '~/dependencies';
import { colors } from '~/layout';

export const Row = lib.styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  height: auto;
  min-height: 45px;
  border: 1px dotted ${colors.lightGray06};
  background-color: ${colors.white02};
  border-radius: 10px;
  padding-left: 0px;
  padding-right: 0px;
  margin-bottom: 4px;
  flex: 1;

  .container {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 45px;
    min-height: 45px;
    justify-content: space-between;
  }
`;

export const BoxTags = lib.styled.div`
  position: absolute;
  display: flex;
  bottom: 0px;
  right: 45px;
`;

export const Tags = lib.styled.div`
  background-color: ${props => props.color};
  width: 20px;
  height: 2px;
  margin-right: 4px;

  &:last-child {
    margin-right: 0px;
  }
`;

export const LeftSide = lib.styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  .icon-direction {
    padding: 0px;
    margin-left: 10px;
    div {
      width: 16px;
      max-width: 16px;
      height: 16px;
      max-height: 16px;
      svg {
        width: 16px;
        height: 16px;
      }
    }
  }

  .box-title {
    display: flex;
    flex-direction: column;
    margin-left: 12px;

    span {
      font-size: 13px;
      color: ${colors.black};
      opacity: 0.5;
    }
  }

  .box-values {
    display: flex;
    flex-direction: column;
    margin-left: 20px;

    span {
      max-width: 200px;
      font-size: 13px;
      color: ${colors.black};
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
`;

export const RightSide = lib.styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  .box-values, .call-date {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    margin-right: 10px;
    line-height: 12px;

    span {
      font-size: 11px;
      color: ${colors.black};
    }
  }

  .player-loading-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 3px;
    margin-right: 5px;

    .MuiCircularProgress-root {
      width: 34px!important;
      height: 34px!important;

    }
    .MuiCircularProgress-colorPrimary {
      color: ${colors.lightBlue};
    }
  }

  .player-off-cotnainer {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 3px;
  }

  .btn-play {
    padding: 0px;
    margin-right: 10px;
    div {
      width: 26px;
      max-width: 26px;
      height: 26px;
      max-height: 26px;
    }
    .icon-play {
      fill: ${colors.green02};
    }
  }

  .btn-play-stop {
    margin-top: -30px;
    padding: 0!important;
  }
`;
